import * as React from "react";
import { Video } from "@grandvisionhq/content";
import { generateConditionalClassNames } from "../../../../utils/containers/RowComponent/utils/utils.js";
/* empty css              */
const CmsRowVideo = ({ component }) => {
  const { coverImage } = component.getModels();
  const { videoUrl, document, horizontalAlignment, verticalAlignment, ...cssStyles } = component.getParameters();
  if (!videoUrl) {
    return null;
  }
  const filteredStyles = Object.fromEntries(
    Object.entries(cssStyles).filter(([_, value]) => value !== "")
  );
  const rowVideoClassName = generateConditionalClassNames("br-row-video", {
    horizontalAlignment,
    verticalAlignment
  });
  return /* @__PURE__ */ React.createElement("div", { className: rowVideoClassName, "data-t": "br-row-video", style: filteredStyles }, /* @__PURE__ */ React.createElement(Video, { videoUrl, coverImage }));
};
export {
  CmsRowVideo,
  CmsRowVideo as default
};
//# sourceMappingURL=RowVideo.js.map
